function initValidate() {
	if (document.querySelector('.js-input-tel')) {
		const tels = document.querySelectorAll('.js-input-tel');

        const event = new Event('input');

		tels.forEach(tel => {
            if (tel.classList.contains('mask')) return;
			const telMask = new Inputmask({
                mask: "+7 (999) 999-99-99",
            }).mask(tel);

            tel.inputmask.option({
                onBeforeMask: function (value, opts) {
                    if(value.length > 0 && value[0] == '8'){
                        value = value.substring(1);
                    }
                    return value;
                }
            });

            tel.addEventListener('input', () => {
                try {
                    tel.dispatchEvent(event);
                } catch (e) {}
            })

            tel.classList.add('mask')
		})
	}

    if (document.querySelector('.js-datepicker')) {
        const pickers = document.querySelectorAll('.js-datepicker');

        pickers.forEach(picker => {
            new Inputmask({mask: "99.99.9999"}).mask(picker);
        })
    }

    if (document.querySelector('.js-form')) {
        const forms = document.querySelectorAll('.js-form');

        forms.forEach(form => {
            if (form.hasAttribute('data-skip-validate')) {
                form.addEventListener('submit', async (e) => {
                    e.preventDefault();

                    if (!e.target.getAttribute('action')) {
                        modals.closeModal()
                        return;
                    }

                    const response = await fetch(e.target.action, {
                        method: 'POST',
                        body: new FormData(form),
                    });
                    const data = await response.json();

                    if (!response.ok) {
                        switch (window.lang) {
                            case 'en': {
                                modalMessage('An error has occurred', 'Refresh the page or try again later');
                                break;
                            }
                            default: {
                                modalMessage('Произошла ошибка', 'Обновите страницу или попробуйте позже');
                            }
                        }
                        return;
                    }

                    if (data.data?.redirect) {
                        window.location.href = data.data.redirect;
                    }

                    if (data.data?.resetForm !== false) {
                        resetForm(form);
                    }

                    // Закрываем именно свою модалку: closeModal() без аргументов ищет её по
                    // location.hash, а его уже стёрло закрытие попапа подтверждения, открытого
                    // поверх формы, — и форма после отправки осталась бы висеть.
                    const ownModal = form.closest('[data-modal]');

                    if (ownModal) {
                        modals.closeModal(null, ownModal.dataset.modal);
                    } else {
                        modals.closeModal();
                    }

                    // Ответ /api идёт без ядрового конверта: restResponse отдаёт тело
                    // контроллера как есть ({message: {title, text}}), а действия модуля —
                    // в ядровом ({data: {message}}), поэтому одного data.data.message мало:
                    // иначе ни успех, ни ошибка, ни флаг перезагрузки не доезжают.
                    const message = data.data?.message
                        || (data.message && typeof data.message === 'object' ? data.message : null);

                    if (message) {
                        const {title, text, button} = message;

                        modalMessage(title, text, button);
                    } else if (data.errors?.[0]?.message) {
                        modalMessage(data.errors[0].message);
                    }
                });
                return;
            }

            let validate = new ValidateForm(form);
            form.validate = validate;

            form.addEventListener('submit', async (e) => {
                e.preventDefault();

                if (!e.target.getAttribute('action')) {
                    modals.closeModal()

                    return;
                }

                const response = await fetch(e.target.action, {
                    method: 'POST',
                    body: new FormData(form),
                });
                const data = await response.json();

                if (!response.ok) {
                    switch (window.lang) {
                        case 'en': {
                            modalMessage('An error has occurred', 'Refresh the page or try again later');
                            break;
                        }
                        default: {
                            modalMessage('Произошла ошибка', 'Обновите страницу или попробуйте позже');
                        }
                    }
                    return;
                }

                if (data.data?.redirect) {
                    window.location.href = data.data.redirect;
                }

                if (data.data?.resetForm !== false) {
                    resetForm(form);
                }

                // Закрываем именно свою модалку: closeModal() без аргументов ищет её по
                // location.hash, а его уже стёрло закрытие попапа подтверждения, открытого
                // поверх формы, — и форма после отправки осталась бы висеть.
                const ownModal = form.closest('[data-modal]');

                if (ownModal) {
                    modals.closeModal(null, ownModal.dataset.modal);
                } else {
                    modals.closeModal();
                }

                // Ответ /api идёт без ядрового конверта: restResponse отдаёт тело
                // контроллера как есть ({message: {title, text}}), а действия модуля —
                // в ядровом ({data: {message}}), поэтому одного data.data.message мало:
                // иначе ни успех, ни ошибка, ни флаг перезагрузки не доезжают.
                const message = data.data?.message
                    || (data.message && typeof data.message === 'object' ? data.message : null);

                // Разбор конверта — сообщение модуля лежит в data.data.message.
                if (message) {
                    const {title, text, button} = message;

                    modalMessage(title, text, button);
                } else if (data.errors?.[0]?.message) {
                    modalMessage(data.errors[0].message);
                }
            });
        });
    }

    if (document.querySelector('.js-form-callback')) {
        const forms = document.querySelectorAll('.js-form-callback');

        forms.forEach(form => {
            new ValidateForm(form);

            form.addEventListener('submit', async (e) => {
                e.preventDefault();

                const response = await fetch(e.target.action, {
                    method: 'POST',
                    body: new FormData(form),
                });

                const data = await response.json();

                if (!response.ok) {
                    switch (window.lang) {
                        case 'en': {
                            modalMessage('An error has occurred', 'Refresh the page or try again later');
                            break;
                        }
                        default: {
                            modalMessage('Произошла ошибка', 'Обновите страницу или попробуйте позже');
                        }
                    }
                    return;
                }

                if (data.data?.redirect) {
                    window.location.href = data.data.redirect;
                }

                if (data.data?.resetForm !== false) {
                    resetForm(form);
                }

                modals.closeModal();

                // Форма резервирования уходит на /api: restResponse отдаёт
                // {message: {title, text}} — без ядровых status и errors.
                const message = data.data?.message
                    || (data.message && typeof data.message === 'object' ? data.message : null);

                if (data.errors?.[0]?.message) {
                    modalMessage(data.errors[0].message);
                } else if (message) {
                    const {title, text, button} = message;

                    modalMessage(title, text, button);
                } else if (data.status === 'success') {
                    modals.openModal(null, form.dataset.formSuccess || '#callback-thanks');
                }
            })
        })
    }

    if (document.querySelector('.js-auth-form')) {
        const forms = document.querySelectorAll('.js-auth-form');

        forms.forEach(form => {
            new ValidateForm(form);
        })
    }

    if (document.querySelector('.js-form-one')) {
        const forms = document.querySelectorAll('.js-form-one');

        forms.forEach(form => {
            new ValidateForm(form);

            const submitBtn = form.querySelector('[type="submit"]');

            submitBtn.setAttribute('disabled', '');

            form.addEventListener('submit', async (e) => {
                e.preventDefault();

                if (!e.target.getAttribute('action')) {
                    modals.closeModal()

                    return;
                }

                const response = await fetch(e.target.action, {
                    method: 'POST',
                    body: new FormData(form),
                });
                const data = await response.json();

                if (!response.ok) {
                    switch (window.lang) {
                        case 'en': {
                            modalMessage('An error has occurred', 'Refresh the page or try again later');
                            break;
                        }
                        default: {
                            modalMessage('Произошла ошибка', 'Обновите страницу или попробуйте позже');
                        }
                    }
                    return;
                }

                if (data.data?.redirect) {
                    window.location.href = data.data.redirect;
                }

                if (data.data?.resetForm !== false) {
                    resetForm(form);
                }

                modals.closeModal();

                const message = data.data?.message
                    || (data.message && typeof data.message === 'object' ? data.message : null);

                if (message) {
                    const {title, text, button} = message;

                    modalMessage(title, text, button);
                } else if (data.errors?.[0]?.message) {
                    modalMessage(data.errors[0].message);
                }
            })

            form.addEventListener('input', checkValidForm)

            function checkValidForm() {
                const file = form.querySelector('[type="file"]');
                const comment = form.querySelector('textarea');

                if (comment.value.length > 2 || file.files.length) {
                    submitBtn.removeAttribute('disabled');
                } else {
                    submitBtn.setAttribute('disabled', '');
                }
            }
        })
    }

    if (document.querySelector('.js-form-review')) {
        const forms = document.querySelectorAll('.js-form-review');

        forms.forEach(form => {
            new ValidateForm(form);

            form.addEventListener('openmodal', (modal) => {
                const productInput = modal.querySelector('[name="fields[product-id]"]');
            })

            form.addEventListener('submit', async (e) => {
                e.preventDefault();

                const response = await fetch(e.target.action, {
                    method: 'POST',
                    body: new FormData(form),
                });

                const data = await response.json();

                if (!response.ok) {
                    switch (window.lang) {
                        case 'en': {
                            modalMessage('An error has occurred', 'Refresh the page or try again later');
                            break;
                        }
                        default: {
                            modalMessage('Произошла ошибка', 'Обновите страницу или попробуйте позже');
                        }
                    }
                    return;
                }

                if (data.data?.redirect) {
                    window.location.href = data.data.redirect;
                }

                if (data.data?.resetForm !== false) {
                    resetForm(form);
                }

                modals.closeModal();

                if (data.status == 'success') {
                    modals.closeModal(null, '#orders-review', modal => {
                        resetForm(modal.querySelector('.js-form-review'));
                    });
                    modals.openModal(null, '#orders-review-thanks');
                } else if (data.errors?.[0]?.message) {
                    modalMessage(data.errors[0].message);
                }
            })
        })
    }
}
